<template>
  <div>
    <form @submit.prevent="$emit('save')">

      <fieldset class="box">
        <legend class="label">Details</legend>

        <b-field label="Title">
          <b-input v-model="post.attributes.title"></b-input>
        </b-field>

        <b-field label="Teaser">
          <b-input v-model="post.attributes.teaser" type="textarea"></b-input>
        </b-field>

        <b-field label="Select datetime">
          <b-datetimepicker
            v-model="post.postedAt"
            rounded
            placeholder="Click to select..."
            :timepicker="{ hourFormat: '12' }"
            horizontal-time-picker>
          </b-datetimepicker>
        </b-field>

        <b-field label="Location">
          <b-input v-model="post.attributes.location"></b-input>
        </b-field>

        <b-field label="Privacy">
          <b-select v-model="post.attributes.privacy" placeholder="Privacy level">
            <option v-for="(value, label) in Privacy" :key="value" :value="value">
              {{ label }}
            </option>
          </b-select>
        </b-field>
      </fieldset>

      <fieldset class="box">
        <legend class="label">Contents</legend>
        <div v-for="(content, index) in post.contents" :key="content.id">
          <!-- TODO add option to un-delete a content block -->
          <content-fields
            :content="content"
            :index="index"
            @add="post.addContent(index)"
            @remove="content.markForDelete()"></content-fields>
        </div>

        <b-button v-if="post.contents.length === 0" @click="post.addContent(-1)">+ Add Content</b-button>
      </fieldset>

      <div class="buttons">
        <b-button type="is-primary" native-type="submit" size="is-large" expanded>Save</b-button>
      </div>

      <div class="has-text-centered">
        <router-link :to="{ name: 'post.show', param: { id: post.attributes.id }}">or cancel</router-link>
      </div>

    </form>
  </div>
</template>

<script>
import { Privacy } from '@/models'
import ContentFields from './content-fields'
export default {
  components: {
    ContentFields
  },
  props: {
    post: Object
  },
  data () {
    return {
      Privacy
    }
  },
  computed: {
    activeContents () {
      return this.post.associations['Content'].filter(i => !i.delete)
    }
  },
  created () {
    if (this.activeContents.length === 0) {
      this.post.addContent(-1)
    }
  }
}
</script>
